import {
  IAddress,
  IUserClientPerson,
  IQuoteApplicationHolder,
} from '@sureapp/platform-sdk';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';

interface ISanitizedHolder
  extends Partial<Omit<IQuoteApplicationHolder, 'address'>> {
  address?: Partial<IAddress>;
}

interface ISanitizedPerson extends Partial<Omit<IUserClientPerson, 'address'>> {
  address?: Partial<IAddress>;
}

function isEmptyWithLatLong(key: string, val: any) {
  return key === 'latitude' || key === 'longitude'
    ? Number.isNaN(val)
    : isEmpty(val);
}

export function sanitizeAddress(address: Partial<IAddress>) {
  const addressKeys = [
    'line1',
    'line2',
    'city',
    'region',
    'county',
    'country',
    'postal',
    'timezone',
    'longitude',
    'latitude',
  ];
  return pickBy(
    address,
    (val, key) => addressKeys.indexOf(key) > -1 && !isEmptyWithLatLong(key, val)
  );
}

export function sanitizeClient(person: Partial<IUserClientPerson>) {
  const clientPersonKeys = [
    'address',
    'first_name',
    'last_name',
    'id',
    'email',
    'dob',
    'phone_number',
    'client_type',
  ];
  const sanitizedPerson: ISanitizedPerson = pickBy(
    person,
    (val, key) => clientPersonKeys.indexOf(key) > -1 && !isEmpty(val)
  );
  if (sanitizedPerson.address) {
    sanitizedPerson.address = sanitizeAddress(sanitizedPerson.address);
  }
  return sanitizedPerson;
}

export function sanitizeHolders(holders: Partial<IQuoteApplicationHolder>[]) {
  const holderKeys = [
    'address',
    'email',
    'first_name',
    'last_name',
    'dob',
    'phone_number',
    'position_on_policy',
  ];
  return holders.map((holder) => {
    const holderCopy: ISanitizedHolder = pickBy(
      holder,
      (val, key) => holderKeys.indexOf(key) > -1 && val !== ''
    );
    holderCopy.address = sanitizeAddress(holderCopy.address!);
    return holderCopy;
  });
}

export function clearSDKState() {
  // TODO: These are updated from the SDK throughout the QF
  // Move this into the SDK as a cleanup function
  window?.sessionStorage?.setItem?.('ineligibleDriverIds', '');
  window?.sessionStorage?.setItem?.('ineligibleVehicleIds', '');
  window?.sessionStorage?.setItem?.('excludedVehiclesList', '');
  window?.sessionStorage?.setItem?.('toggleAutoSignedDocs', '');
}
